var _circle, _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_6834_9243)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6834_9243)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7998 18.3001H9.5998V6.6001H7.7998V18.3001ZM14.6998 18.3001H16.4998V6.6001H14.6998V18.3001ZM10.4998 15.3001V13.5001L13.7998 13.5001V15.3001H10.4998ZM10.4998 9.9001V11.7001H13.7998V9.9001L10.4998 9.9001Z",
    fill: "#D11F00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1001 18H9.9001V6.30005H8.1001V18ZM15.0001 18H16.8001V6.30005H15.0001V18ZM10.8001 15V13.2H14.1001V15H10.8001ZM10.8001 9.60005V11.4H14.1001V9.60005H10.8001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 0.014739C6.25133 0.327358 1.2 5.57378 1.2 12C1.2 18.4262 6.25134 23.6726 12.6 23.9853C12.4012 23.995 12.2012 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C12.2012 0 12.4012 0.0049514 12.6 0.014739Z",
    fill: "url(#paint1_linear_6834_9243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6834_9243",
    x: 6.7998,
    y: 5.6001,
    width: 10.7002,
    height: 13.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_6834_9243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6834_9243",
    x1: 24,
    y1: 0,
    x2: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08713,
    stopColor: "#FFFACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766097,
    stopColor: "#F8C300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6834_9243",
    x1: 2.4,
    y1: 1.8,
    x2: 2.4,
    y2: 23.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECD8AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF8705"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHay);
export default __webpack_public_path__ + "static/media/HAY.472527ac76736e97a28061df870181f6.svg";
export { ForwardRef as ReactComponent };